import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import AdminHeader from "../components/AdminHeader";
import AdminSidebar from "../components/AdminSidebar";
import AdminFooter from "../components/AdminFooter";

const AdminLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(true);

  return (
    <div
      className={`app-wrapper ${
        sidebarOpen ? "sidebar-open" : "sidebar-closed"
      }`}
    >
      <AdminHeader toggleSidebar={() => setSidebarOpen(!sidebarOpen)} />

      <AdminSidebar sidebarOpen={sidebarOpen} />

      <main className="content">
        <Outlet />
      </main>

      <AdminFooter />
    </div>
  );
};

export default AdminLayout;
